export const fonts = {
  book: "var(--font-book)",
  demi: "var(--font-demi)",
  light: "var(--font-light)",
  medium: "var(--font-medium)",
  apercu: "var(--font-apercu)",
  acuminRegular: "var(--font-acumin-regular)",
  acuminLight: "var(--font-acumin-light)",
  acuminMedium: "var(--font-acumin-medium)",
  acuminBold: "var(--font-acumin-bold)",
  acuminBoldItalic: "var(--font-acumin-bolditalic)",
  acuminSemiBold: "var(--font-acumin-semibold)",
  boldOblique: "var(--font-bold-oblique)",
}
